import React, { useEffect, useState } from "react";
import Navbar from "../../bars/Navbar";
import Sidebar from "../../bars/Sidebar";
import WithRouter from "../../common/WithRouter";
import {
  Table,
  Button,
  Badge,
  Row,
  Modal,
  Col,
  InputGroup,
  Form,
  Accordion,
  Card,
  Pagination
} from "react-bootstrap";
import { DeleteDenuncia, DeleteSeguimiento, descargarBannerCurso, enviarSeguimientoPorCorreo, fetchQuejaById, fetchQuejas, updateQuejaAtendidoStatus } from "../../services/apiService";
//import { AiOutlineReload } from "react-icons/ai";

import { jwtDecode } from "jwt-decode";

import { downloadQuejaFile } from "../../services/fileService";
import "../../App.css";
import {
  BsFileEarmarkText,
  BsFillPersonLinesFill,
  BsCloudDownloadFill,
  BsChevronLeft,
  BsChevronRight,
  BsEyeFill,
  BsCalendar2DateFill,
  BsCheckCircleFill,
  BsFillExclamationTriangleFill,
  BsSendFill,
  Bs123,
  BsBuildingsFill,
  BsBuildingFillExclamation,
  BsSignpostSplitFill,
  BsFillPinMapFill,
  BsFillPinAngleFill,
  BsGrid1X2Fill,
  BsGrid3X3GapFill,
  BsFilterLeft,
  BsSliders,
  BsAndroid,
  BsFillTelephoneFill,
  BsGenderAmbiguous,
  BsFillEnvelopeAtFill,
  BsChevronExpand,
  BsFillTrash2Fill,
  BsFillTrash3Fill,
  BsFillTrashFill,
  BsSearch,
  BsEraserFill,
} from "react-icons/bs";
import { Link } from "react-router-dom";
import { FcSearch } from "react-icons/fc";

export const Quejas = () => {
  const [queja, setQueja] = useState(null);
  // eslint-disable-next-line
  const [quejaquejante, setQuejaQuejante] = useState(null);

  const token = localStorage.getItem("jwt"); // Obtener el token JWT desde localStorage

  const userRole = token ? jwtDecode(token).rol : null;
  // eslint-disable-next-line
  const Name = token ? jwtDecode(token).sub : null;
  // eslint-disable-next-line
  const Visor = "Visor";
  // eslint-disable-next-line
  const SPCTI = "SPCTI";
  const Administrador = "Administrador";
  const Senior = "Senior";


  document.title = "Tabla de Denuncias";

  const [quejas, setQuejas] = useState([]);

  const URL = "https://sidec.veracruz.gob.mx";
  //const URL = "https://buzon";

  // Descargar Evidencia
  const handleDownload = async (id, fileName) => {
    try {
      const response = await downloadQuejaFile(id);

      // Crear enlace temporal
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName || `queja_${id}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error en la descarga:", error);
      // Puedes agregar un mensaje de error al usuario aquí
    }
  };

  ////////////////////////////////

  /////////////// CARGAR QUEJAS ///////////////////////
  // modal delete
  const [denunciaToDelete, setDenunciaToDelete] = useState(null);
  const [showConfirmModalDenuncia, setShowConfirmModalDenuncia] = useState(false);
  const [isDeletingDenuncia, setIsDeletingDenuncia,] = useState(false);
  const [deleteErrorDenuncia, setDeleteErrorDenuncia,] = useState(null);

  // modal delete seguimiento

  const [seguimientoToDelete, setSeguimientoToDelete] = useState(null);
  const [showConfirmModalSeguimiento, setShowConfirmModalSeguimiento] = useState(false);
  const [isDeletingSeguimiento, setIsDeletingSeguimiento,] = useState(false);
  const [deleteErrorSeguimiento, setDeleteErrorSeguimiento,] = useState(null);


  // Estados para paginación
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0); // Nuevo estado para total de elementos
  const [pageSize, setPageSize] = useState(10); // Estado para el tamaño de página

  const [anioInput, setAnioInput] = useState('');
  const [mesInput, setMesInput] = useState('');
  const [atendidoInput, setAtendidoInput] = useState('');
  const [searchTerm, setSearchTerm] = useState("");

  // Lo que realmente filtra
  const [anio, setAnio] = useState(null);
  const [mes, setMes] = useState(null);
  const [atendido, setAtendido] = useState(null);


  const handleAplicarFiltros = () => {
    setCurrentPage(0); // volver a la primera página
    setAnio(anioInput || null);
    setMes(mesInput || null);
    setAtendido(atendidoInput || null);
  };
  const handleLimpiarFiltros = () => {
    setSearchTerm('');
    setAnioInput('');
    setAnio('');
    setMesInput('');
    setMes('');
    setAtendidoInput('');
    setAtendido('');
    setCurrentPage(0);
  };

  const loadQuejas = async () => {

    try {
      const response = await fetchQuejas(
        currentPage,
        pageSize,
        anio,
        mes,
        atendido,
        searchTerm,
      );

      setQuejas(response.content);
      setTotalPages(response.totalPages);
      setTotalElements(response.totalElements || 0);
    } catch (error) {

      setQuejas([]);
      setTotalPages(0);
      setTotalElements(0);
    }

  };
  useEffect(() => {
    loadQuejas();
    // eslint-disable-next-line
  }, [
    currentPage,
    pageSize,
    anio,
    mes,
    atendido,
    searchTerm,

  ]);

  // Inicio Paginación
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
  };
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(0);
  };
  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };
  const handleNext = () => {
    if (totalPages === 0) return;

    setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
  };
  const getPaginationItems = () => {
    let items = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);
    // Ajustar si estamos cerca del final
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(0, endPage - maxVisiblePages + 1);
    }
    // Primera página
    if (startPage > 0) {
      items.push(
        <Pagination.Item
          key={1}
          active={currentPage === 0}
          onClick={() => handlePageChange(1)}
        >
          1
        </Pagination.Item>
      );
      if (startPage > 1) {
        items.push(<Pagination.Ellipsis key="ellipsis-start" />);
      }
    }
    // Páginas intermedias
    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i + 1}
          active={i === currentPage}
          onClick={() => handlePageChange(i + 1)}
        >
          {i + 1}
        </Pagination.Item>
      );
    }
    // Última página
    if (endPage < totalPages - 1) {
      if (endPage < totalPages - 2) {
        items.push(<Pagination.Ellipsis key="ellipsis-end" />);
      }
      items.push(
        <Pagination.Item
          key={totalPages}
          active={currentPage === totalPages - 1}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }
    return items;
  };
  // Fin Paginación

  /* const handleRecargar = () => {
    window.location.reload();
  }; */

  const resetForm = () => {
    setConfirmMessage(null);
    setErrorInput(null);
    setNotas("");
    setMetodo(null);
    setArchivo(null);

  };

  const handleVerEvidencia = async (id) => {
    try {
      setErrorInput("");
      await descargarBannerCurso(id);
    } catch (error) {
      if (error.response?.status === 404) {
        setErrorInput("Este seguimiento no tiene evidencia adjunta.");
        setTimeout(async () => { setErrorInput("") }, 1000);
      } else {
        setErrorInput("Ocurrió un error al intentar abrir la evidencia.");
      }
    }
  };


  const [showModal, setShowModal] = useState(false);
  const [selectedQuejaId, setSelectedQuejaId] = useState(null);
  const [notas, setNotas] = useState("");
  const [metodo, setMetodo] = useState("");
  const [archivo, setArchivo] = useState([]);

  const [sendingIds, setSendingIds] = useState(new Set());

  const handleOpenModal = (id) => {
    setSelectedQuejaId(id);
    setShowModal(true);
  };
  const handleSubmitNotas = async () => {

    if (!notas.trim()) {
      setErrorInput("El campo detalle no puede ir vacío");
      setTimeout(async () => {
        setErrorInput("");
      }, 1000);
      return;
    }

    if (!metodo.trim()) {
      setErrorInput("El campo mecanismo de seguimiento");
      setTimeout(async () => {
        setErrorInput("");
      }, 1000);
      return;
    }

    try {
      const formData = new FormData();

      formData.append("file", archivo);
      formData.append(
        "seguimiento",
        JSON.stringify({
          atendido: true,
          notas: notas,
          metodo: metodo
        })
      );

      await updateQuejaAtendidoStatus(selectedQuejaId, formData);
      const quejaActualizada = await fetchQuejaById(selectedQuejaId);

      setQueja({
        ...quejaActualizada,
        seguimientos: [...quejaActualizada.seguimientos]
      });
      setFormDataQuejaDetail({
        atendido: quejaActualizada.atendido,
      });


      setConfirmMessage("¡Notas guardadas correctamente!");
      setTimeout(async () => {
        await loadQuejas();
        setShowModal(false);
        setShowModalDetailQueja(false);
        setConfirmMessage("");
        resetForm();

      }, 2000);

    } catch (error) {
      console.error("Error en la solicitud:", error);
      alert("Error al enviar las notas: " + error.message);
    }


  };

  const handleEnviarCorreo = async (segId) => {
    if (!segId) return;
    const next = new Set(sendingIds);
    next.add(segId);
    setSendingIds(next);

    try {
      await enviarSeguimientoPorCorreo(segId);
      setConfirmMessage("¡Correo enviado con éxito!");
      setTimeout(async () => {
        setConfirmMessage("");
      }, 1000);

    } catch (err) {
      console.error(err);
      window.alert(`Error al enviar el correo: ${err.message}`);
    } finally {
      const clean = new Set(sendingIds);
      clean.delete(segId);
      setSendingIds(clean);
    }
  };
  // justo antes del return (después de cargar `queja`)
  const seguimientos = Array.isArray(queja?.seguimientos) ? queja.seguimientos : [];
  // Orden descendente por fechaActualizacion sin mutar el original
  const ordenados = [...seguimientos].sort(
    (a, b) => new Date(b?.fechaActualizacion || 0) - new Date(a?.fechaActualizacion || 0)
  );
  // El más reciente (si existe)
  const ultimo = ordenados[0] || null;

  const [showModalDetailQueja, setShowModalDetailQueja] = useState(false);
  const [showModalDetailQuejaQuejante, setShowModalDetailQuejaQuejante] = useState(false);

  const [errorInput, setErrorInput] = useState(null);
  const [ConfirmMessage, setConfirmMessage] = useState(null);

  // Detail Queja
  const [formDataQuejaDetail, setFormDataQuejaDetail] = useState({
    id: "",
    folio: "",
    fecha: "",
    einstitucion: "",
    eginstitucion: "",
    enumero: "",
    ecalles: "",
    municipio: "",
    localidad: "",
    dqueja: "",
    actividad: "",
    riesgo: "",
    atendido: "",


  });
  const handleOpenModalDetailQueja = async (id) => {
    setShowModalDetailQueja(true);

    try {
      const formDataQuejaDetail = await fetchQuejaById(id);
      setQueja(formDataQuejaDetail || "");
      setFormDataQuejaDetail({
        //Variable <======================== BD
        id: formDataQuejaDetail.id,
        folio: formDataQuejaDetail.folio,
        fecha: formDataQuejaDetail.fecha,
        einstitucion: formDataQuejaDetail.einstitucion,
        eginstitucion: formDataQuejaDetail.eginstitucion,
        enumero: formDataQuejaDetail.enumero,
        ecalles: formDataQuejaDetail.ecalles,
        municipio: formDataQuejaDetail?.localidad.municipio.municipio,
        localidad: formDataQuejaDetail?.localidad.localidad,
        dqueja: formDataQuejaDetail.dqueja,
        actividad: formDataQuejaDetail?.actividad.actividad,
        subActividad: formDataQuejaDetail?.subActividad.actividad,
        riesgo: formDataQuejaDetail?.subActividad.riesgo,
        atendido: formDataQuejaDetail.atendido,

      })

    } catch (error) {

      setErrorInput(error || "Ocurrió un error inesperado");
    }
  }

  // Detail Quejante
  const [formDataQuejaDetailQuejante, setFormDataQuejaDetailQuejante] = useState({
    id: "",
    fecha: "",
    folio: "",
    dnombre: "",
    dtelefono: "",
    genero: "",
    municipio: "",
    localidad: "",
    dcorreo: "",
    notificacion: "",
    atendido: ""
  });

  const handleOpenModalDetailQuejaQuejante = async (id) => {
    setShowModalDetailQuejaQuejante(true);

    try {
      const formDataQuejaDetailQuejante = await fetchQuejaById(id);
      setQuejaQuejante(formDataQuejaDetailQuejante || "");
      setFormDataQuejaDetailQuejante({
        //Variable <======================== BD
        id: formDataQuejaDetailQuejante.id,
        fecha: formDataQuejaDetailQuejante.fecha,
        folio: formDataQuejaDetailQuejante.folio,
        dnombre: formDataQuejaDetailQuejante.dnombre,
        dtelefono: formDataQuejaDetailQuejante.dtelefono,
        genero: formDataQuejaDetailQuejante?.genero.genero,
        municipio: formDataQuejaDetailQuejante?.dlocalidad.municipio.municipio,
        localidad: formDataQuejaDetailQuejante?.dlocalidad?.localidad,
        dcorreo: formDataQuejaDetailQuejante.dcorreo,
        notificacion: formDataQuejaDetailQuejante?.notificacion,
        atendido: formDataQuejaDetailQuejante.atendido
      })


    } catch (error) {

      setErrorInput(error || "Ocurrió un error inesperado");
    }
  }

  const handleDelete = async (id) => {
    setDenunciaToDelete(id); // Guarda el ID para usarlo después
    setShowConfirmModalDenuncia(true); // Muestra el modal de confirmación
  };
  const handleConfirmDeleteDenuncia = async () => {
    if (!denunciaToDelete) return;

    setIsDeletingDenuncia(true);
    setDeleteErrorDenuncia(null);

    try {
      await DeleteDenuncia(denunciaToDelete);
      await loadQuejas();
    } catch (error) {
      setDeleteErrorDenuncia(error.message || "Error al eliminar el comisiones");
    } finally {
      setIsDeletingDenuncia(false);
      setDeleteErrorDenuncia(false);
      setShowConfirmModalDenuncia(false); // Cierra el modal
      setDenunciaToDelete(null); // Limpia el ID almacenado
    }
  };

  const handleDeleteSeguimiento = async (id) => {
    setSeguimientoToDelete(id); // Guarda el ID para usarlo después
    setShowConfirmModalSeguimiento(true); // Muestra el modal de confirmación
  };
  const handleConfirmDeleteSeguimiento = async () => {
    if (!seguimientoToDelete) return;

    setIsDeletingSeguimiento(true);
    setDeleteErrorSeguimiento(null);

    try {
      await DeleteSeguimiento(seguimientoToDelete);
      await loadQuejas();
    } catch (error) {
      setDeleteErrorSeguimiento(error.message || "Error al eliminar el seguimiento");
    } finally {
      setIsDeletingSeguimiento(false);
      setDeleteErrorSeguimiento(false);
      setShowConfirmModalSeguimiento(false); // Cierra el modal
      setShowModalDetailQueja(false); // Cierra el modal
      setSeguimientoToDelete(null); // Limpia el ID almacenado
    }
  };

  return (
    <>
      {/* Detalle Queja */}
      <Modal show={showModalDetailQueja} onHide={() => setShowModalDetailQueja(false)} size="xl" backdrop="static">
        <Modal.Header>
          <Modal.Title><BsFillExclamationTriangleFill /> Detalle de la Queja</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* FInicio, FFin, Destino */}
            <Row>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Folio</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <Bs123 /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="dqueja"
                      className="form-control"
                      value={formDataQuejaDetail.folio}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Fecha</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsCalendar2DateFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="fecha"
                      className="form-control"
                      value={formDataQuejaDetail.fecha?.split(".")[0]}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Empresa</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsBuildingsFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="einstitucion"
                      className="form-control"
                      value={formDataQuejaDetail.einstitucion}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Giro</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsBuildingFillExclamation /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="eginstitucion"
                      className="form-control"
                      value={formDataQuejaDetail.eginstitucion}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Entre Calles</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsSignpostSplitFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="ecalles"
                      className="form-control"
                      value={formDataQuejaDetail.ecalles}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={2}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Municipio</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsFillPinMapFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="municipio"
                      className="form-control"
                      value={formDataQuejaDetail.municipio}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={2}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Localidad</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsFillPinAngleFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="localidad"
                      className="form-control"
                      value={formDataQuejaDetail.localidad}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Actividad</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsGrid1X2Fill /> {" "}
                    </InputGroup.Text>
                    <textarea
                      rows={3}
                      name="actividad"
                      className="form-control"
                      value={formDataQuejaDetail.actividad}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>SubActividad</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsGrid3X3GapFill /> {" "}
                    </InputGroup.Text>
                    <textarea
                      rows={3}
                      name="subActividad"
                      className="form-control"
                      value={formDataQuejaDetail.subActividad}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Riesgo</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsFillExclamationTriangleFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="riesgo"
                      className="form-control"
                      value={formDataQuejaDetail.riesgo}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={12}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Detalle de la Queja</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsFilterLeft /> {" "}
                    </InputGroup.Text>
                    <textarea
                      rows="3"
                      name="riesgo"
                      className="form-control"
                      value={formDataQuejaDetail.dqueja}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>

              <Col Col xs={12} md={6} lg={6}>
                <strong>Actualizar Estatus : </strong> ㅤ
                {userRole === Administrador || userRole === Senior ? (
                  <>
                    {formDataQuejaDetail.atendido === true ? (
                      <Button
                        variant="success"

                        //disabled
                        onClick={() => handleOpenModal(formDataQuejaDetail.id)} // Este botón abre el modal
                      >
                        <BsCheckCircleFill /> Denuncia Atendida
                      </Button>
                    ) : (
                      <Button
                        variant="warning"

                        onClick={() => handleOpenModal(formDataQuejaDetail.id)} // Este botón abre el modal
                      >
                        <BsCheckCircleFill /> Seguimiento
                      </Button>
                    )}
                  </>
                ) : (
                  <p>
                    <p className="rojo">
                      Solo el Rol Administrador puede dar seguimiento
                    </p>
                    <Button variant="danger" size="sm" disabled>
                      <BsCheckCircleFill /> Seguimiento
                    </Button>
                  </p>
                )}
              </Col>

              <Col Col xs={12} md={6} lg={3}>
                <strong>Atendido : </strong>
                {formDataQuejaDetail.atendido ? (
                  <Badge bg="success">Sí</Badge>
                ) : (
                  <Badge bg="danger">No</Badge>
                )}
              </Col>


            </Row>
          </Form>
          <br />
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header><BsSliders />ㅤ <b>Seguimientos </b></Accordion.Header>
              <Accordion.Body>
                {seguimientos.length > 0 ? (
                  <>
                    <div className="mt-4 pt-3 border-top">
                      {/* Resumen del último */}
                      <div className="mb-3">
                        <h6 className="mb-2">Último seguimiento</h6>
                        <p><strong>Nota: </strong>{ultimo?.comentario || "—"}</p>
                        <p><strong>Método: </strong>{ultimo?.metodo || "—"}</p>

                        <p>
                          <strong>Atendido por: </strong>
                          <Badge bg="secondary">{ultimo?.editadoPor || ""}</Badge>
                        </p>
                        <p>
                          <strong>Fecha: </strong>
                          {ultimo?.fechaActualizacion ? ultimo.fechaActualizacion.split("T")[0] : "—"}
                        </p>
                      </div>

                      {/* Historial completo */}
                      <h6 className="mb-2">Historial</h6>
                      <ul className="list-group">
                        {ordenados.map((s, idx) => (
                          <li key={s?.id ?? idx} className="list-group-item">
                            <div className="d-flex justify-content-between align-items-start gap-2">
                              <div className="flex-grow-1">
                                <div>
                                  <strong>{s?.metodo || "Sin método"}</strong> — {s?.comentario || "Sin comentario"}
                                </div>
                                <div className="text-muted small">
                                  {s?.ultimoEditor?.nombres || ""} {s?.ultimoEditor?.apellidos || ""} ·{" "}
                                  {s?.fechaActualizacion ? s.fechaActualizacion.split("T")[0] : ""}
                                </div>
                              </div>
                              <Link>
                                <Button
                                  variant="warning"
                                  size="sm"
                                  title="Ver Banner"
                                  onClick={() => handleVerEvidencia(s?.id)}
                                //disabled={!banner}
                                >
                                  <BsEyeFill /> Ver Anexo
                                </Button>
                              </Link>
                              <div className="text-nowrap">
                                <Button
                                  variant="dark"
                                  size="sm"
                                  onClick={() => handleEnviarCorreo(s?.id)}
                                  disabled={sendingIds.has(s?.id) || userRole !== 'Administrador'}
                                  title="Enviar por correo este seguimiento"
                                >
                                  <BsSendFill /> {sendingIds.has(s?.id) ? "Enviando..." : "Enviar Notificación por correo"}
                                </Button>
                              </div>
                              <Link>
                                <Button
                                  className="btn btn-danger"
                                  onClick={() => handleDeleteSeguimiento(s?.id)}
                                  disabled={userRole !== Administrador}
                                >
                                  <BsFillTrash3Fill />
                                </Button>
                              </Link>
                            </div>
                          </li>
                        ))}
                      </ul>

                    </div>
                  </>
                ) : (
                  "No hay seguimiento hasta el momento"
                )
                }
                <br />
                {/* Mensaje de success */}
                {ConfirmMessage && (
                  <div className="alert alert-success" role="alert">
                    {ConfirmMessage}
                  </div>
                )}
                {/* Mensaje de error */}
                {errorInput && (
                  <div className="alert alert-danger" role="alert">
                    {errorInput}
                  </div>
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModalDetailQueja(false);
              resetForm();
            }}
          >
            Cerrar
          </Button>
          {/* <Button variant="success" onClick={handleSubmitGasto} disabled={loading} >
            {loading ? "Guardando..." : "Guardar"}
          </Button> */}

        </Modal.Footer>

      </Modal>
      {/* Detalle Queja Quejante */}
      <Modal show={showModalDetailQuejaQuejante} onHide={() => setShowModalDetailQuejaQuejante(false)} size="xl" backdrop="static">
        <Modal.Header>
          <Modal.Title><BsFillPersonLinesFill /> Detalle del Denunciante</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* FInicio, FFin, Destino */}
            <Row>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Folio</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <Bs123 /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="dqueja"
                      className="form-control"
                      value={formDataQuejaDetailQuejante.folio}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Fecha</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsCalendar2DateFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="fecha"
                      className="form-control"
                      value={formDataQuejaDetailQuejante.fecha?.split(".")[0]}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Nombre</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsAndroid /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="dnombre"
                      className="form-control"
                      value={formDataQuejaDetailQuejante.dnombre}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Teléfono</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsFillTelephoneFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="dtelefono"
                      className="form-control"
                      value={formDataQuejaDetailQuejante.dtelefono}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={4}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Género</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsGenderAmbiguous /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="genero"
                      className="form-control"
                      value={formDataQuejaDetailQuejante.genero}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={2}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Municipio</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsFillPinMapFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="municipio"
                      className="form-control"
                      value={formDataQuejaDetailQuejante.municipio}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={2}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Localidad</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsFillPinAngleFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="localidad"
                      className="form-control"
                      value={formDataQuejaDetailQuejante.localidad}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={5}>
                <div className="form-group mb-4">
                  <label className="form-label">
                    <b>Correo</b>
                  </label>
                  <InputGroup className="">
                    <InputGroup.Text id="basic-addon1">
                      <BsFillEnvelopeAtFill /> {" "}
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="dcorreo"
                      className="form-control"
                      value={formDataQuejaDetailQuejante.dcorreo}
                      readOnly
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col Col xs={12} md={6} lg={3}>
                <strong>Desea recibir correos promocionales : </strong>
                {formDataQuejaDetailQuejante.notificacion ? (
                  <Badge bg="success">Sí</Badge>
                ) : (
                  <Badge bg="danger">No</Badge>
                )}
              </Col>
              <Col Col xs={12} md={6} lg={3}>
                <strong>Atendido : </strong>
                {formDataQuejaDetailQuejante.atendido ? (
                  <Badge bg="success">Sí</Badge>
                ) : (
                  <Badge bg="danger">No</Badge>
                )}
              </Col>



            </Row>
          </Form>
          {/* Mensaje de success */}
          {ConfirmMessage && (
            <div className="alert alert-success" role="alert">
              {ConfirmMessage}
            </div>
          )}
          {/* Mensaje de error */}
          {errorInput && (
            <div className="alert alert-danger" role="alert">
              {errorInput}
            </div>
          )}

        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModalDetailQuejaQuejante(false);
              resetForm();
            }}
          >
            Cerrar
          </Button>
        </Modal.Footer>

      </Modal>
      {/* Ingresar notas */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Ingresar notas</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col Col xs={12} md={6} lg={12}>
              <div className="form-group mb-4">
                <label className="form-label">
                  <b>Descripción de la Atención (100 carácteres)</b>
                </label>
                <InputGroup className="">
                  <InputGroup.Text id="basic-addon1">
                    <Bs123 /> {" "}
                  </InputGroup.Text>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    maxLength={100}
                    value={notas}
                    onChange={(e) => setNotas(e.target.value)}
                    placeholder="Detalles de la atención..."
                  />
                </InputGroup>
              </div>
            </Col>

            <Col Col xs={12} md={6} lg={12}>
              <div className="form-group mb-4">
                <label className="form-label">
                  <b>Seleccione el mecanismo de seguimiento</b>
                </label>
                <InputGroup className="">
                  <InputGroup.Text id="basic-addon1">
                    <Bs123 /> {" "}
                  </InputGroup.Text>

                  <select
                    class="form-select"
                    aria-label="Default select example"
                    value={metodo}
                    onChange={(e) => setMetodo(e.target.value)}
                  >
                    <option selected value="">--Método de Seguimiento--</option>
                    <option value="Llamada Telefonica">Llamada Telefonica</option>
                    <option value="Correo Electrónico">Correo Electrónico</option>
                    <option value="Canalizado a otra dependencia">
                      Canalizado a otra dependencia
                    </option>
                    <option value="Queja/Denuncia no procede">
                      Queja/Denuncia no procede
                    </option>
                  </select>
                </InputGroup>
              </div>
            </Col>
            <Col Col xs={12} md={6} lg={12}>
              <div className="form-group mb-4">
                <label className="form-label">
                  <b>Anexe documento de respuesta (previamente escaneado en formato PDF)</b>
                </label>
                <InputGroup className="">
                  <InputGroup.Text id="basic-addon1">
                    <Bs123 /> {" "}
                  </InputGroup.Text>
                  <Form.Control
                    type="file"
                    className="form-control"
                    accept="application/pdf"
                    name="archivo"
                    //value={archivo}
                    onChange={(e) => setArchivo(e.target.files[0])}
                  />
                </InputGroup>
              </div>
            </Col>
          </Row>

          {/* Mensaje de success */}
          {ConfirmMessage && (
            <div className="alert alert-success" role="alert">
              {ConfirmMessage}
            </div>
          )}
          {/* Mensaje de error */}
          {errorInput && (
            <div className="alert alert-danger" role="alert">
              {errorInput}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary"
            onClick={() => {
              setShowModal(false)
              resetForm()
            }}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleSubmitNotas}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Eliminar Denuncia */}
      <Modal
        show={showConfirmModalDenuncia}
        onHide={() => setShowConfirmModalDenuncia(false)}
        centered
      >
        <Modal.Header>
          <Modal.Title><BsFillTrashFill /> Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas eliminar esta denuncia? <b>Esta acción no se
            puede deshacer.</b>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModalDenuncia(false)}
            disabled={isDeletingDenuncia}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirmDeleteDenuncia}
            disabled={isDeletingDenuncia}
          >
            {isDeletingDenuncia ? "Eliminando..." : "Sí, eliminar"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Eliminar Seguimiento */}
      <Modal
        show={showConfirmModalSeguimiento}
        onHide={() => setShowConfirmModalSeguimiento(false)}
        centered
      >
        <Modal.Header>
          <Modal.Title><BsFillTrashFill /> Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas eliminar este seguimiento? <b>Esta acción no se
            puede deshacer.</b>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModalSeguimiento(false)}
            disabled={isDeletingSeguimiento}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirmDeleteSeguimiento}
            disabled={isDeletingSeguimiento}
          >
            {isDeletingSeguimiento ? "Eliminando..." : "Sí, eliminar"}
          </Button>
        </Modal.Footer>
      </Modal>



      <div className="flex">
        <Sidebar />
        <div className="content w-100 cont">
          <Navbar />
          <div className="col-md-12">
            <h3 className="text-center">
              <b> Lista de Denuncias Ciudadanas { } ({totalElements})</b>
              {/* <Button variant="info" size="sm" onClick={handleRecargar}>
                <AiOutlineReload />
              </Button> */}
            </h3>

            <Card className="card-tabla">
              <Table
                size="sm"
                hover
                responsive
                className="tablecursos text-center">
                <thead>
                  <tr className="text-center">
                    <th>Folio</th>
                    <th>Fecha</th>
                    <th>Razón Social</th>
                    {/* <th>Dirección</th> */}
                    <th>Municipio</th>
                    <th>Actividad</th>
                    <th>Denunciante</th>
                    <th className="sizepruebas">Pruebas</th>
                    <th colSpan={3}>Detalle</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {quejas.length > 0 ? (
                    quejas.map((queja) => (
                      <tr key={queja.id}>
                        <td>{queja.folio}</td>
                        <td>{queja.fecha.split("T")[0]}</td>
                        <td>{queja.einstitucion}</td>
                        <td>{queja.localidad.municipio.municipio}</td>
                        <td>{queja.actividad.actividad}</td>
                        <td>{queja.dnombre}</td>
                        <td className="text-center">
                          {queja.evidencia?.storedName ? (
                            <>
                              <Button
                                variant="warning"
                                size="sm"
                                onClick={() =>
                                  handleDownload(
                                    queja.id,
                                    queja.evidencia.name
                                  )
                                }
                                className="me-2"
                                title="Descargar evidencia"
                              >
                                <BsCloudDownloadFill />
                              </Button>
                              <Button

                                variant="success"
                                size="sm"
                                onClick={() => {
                                  const width = 800;
                                  const height = 600;
                                  const left = (window.screen.width - width) / 2;
                                  const top = (window.screen.height - height) / 2;

                                  const features = `
                                  width=${width},
                                  height=${height},
                                  left=${left},
                                  top=${top},
                                  scrollbars=yes,
                                  resizable=yes,
                                  toolbar=no,
                                  menubar=no,
                                  lang=es,
                                  location=no,
                                  status=no
                                `;

                                  window.open(
                                    `${URL}/api/files/view/queja/${queja.id}`,
                                    `evidencia_${queja.id}`,
                                    features
                                  );
                                }}
                                title="Visualizar evidencia"
                              >
                                <BsEyeFill />

                              </Button>
                            </>
                          ) : (
                            <span className="text-muted">Sin Evidencia</span>
                          )}
                        </td>
                        <td>
                          <Button
                            className="btn btn-dark"
                            onClick={() => handleOpenModalDetailQueja(queja.id)}
                          >
                            <BsFileEarmarkText
                            />
                          </Button>
                        </td>
                        <td>
                          <Button
                            className="btn btn-dark"
                            onClick={() => handleOpenModalDetailQuejaQuejante(queja.id)}
                          >
                            <BsFillPersonLinesFill />
                          </Button>
                        </td>

                        <td>
                          {queja.atendido ? (
                            <Badge bg="success">Atendido</Badge>
                          ) : (
                            <Badge bg="danger">No Atendido</Badge>
                          )}
                        </td>
                        <td>
                          <Button
                            className="btn btn-danger"
                            onClick={() => handleDelete(queja.id)}
                            disabled={userRole !== Administrador}
                          >
                            <BsFillTrash3Fill />
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="11" className="text-center">
                        No hay registros para mostrar
                      </td>
                    </tr>
                  )}

                </tbody>
              </Table>
            </Card>



            <Card className="card-fix">
              {/* Controles de Paginación */}
              <div className="d-flex justify-content-between align-items-center mb-1">
                <div className="d-flex align-items-center gap-2">

                  <Col Col xs={12} md={6} lg={2}>
                    <div className="form-group mb-4">
                      <label className="form-label">
                        <b>Folio</b>
                      </label>
                      <InputGroup className="">
                                             
                        <InputGroup.Text>
                          <FcSearch />
                        </InputGroup.Text>
                        <Form.Control
                          placeholder="Buscar folio ..."
                          value={searchTerm}
                          onChange={handleSearch}
                        />

                      </InputGroup>
                    </div>
                  </Col>
                  <Col Col xs={12} md={6} lg={3}>
                    <div className="form-group mb-4">
                      <label className="form-label">
                        <b>Año</b>
                      </label>
                      <InputGroup className="">
                        <InputGroup.Text id="basic-addon1">
                          <BsChevronExpand /> {" "}
                        </InputGroup.Text>
                        <Form.Select
                          className="form-control"
                          name="anioInput"
                          value={anioInput}
                          onChange={(e) => setAnioInput(e.target.value)}
                        >
                          <option value="">-- Seleccione año --</option>
                          <option value="2025">2025</option>
                          <option value="2026">2026</option>
                          <option value="2027">2027</option>
                          <option value="2028">2028</option>
                          <option value="2029">2029</option>
                          <option value="2030">2030</option>
                        </Form.Select>

                      </InputGroup>
                    </div>
                  </Col>
                  <Col Col xs={12} md={6} lg={3}>
                    <div className="form-group mb-4">
                      <label className="form-label">
                        <b>Mes</b>
                      </label>
                      <InputGroup className="">
                        <InputGroup.Text id="basic-addon1">
                          <BsChevronExpand /> {" "}
                        </InputGroup.Text>
                        <Form.Select
                          className="form-control"
                          name="mesInput"
                          value={mesInput}
                          onChange={(e) => setMesInput(e.target.value)}
                        >
                          <option value="">-- Seleccione mes --</option>
                          <option value="1">Enero</option>
                          <option value="2">Febrero</option>
                          <option value="3">Marzo</option>
                          <option value="4">Abril</option>
                          <option value="5">Mayo</option>
                          <option value="6">Junio</option>
                          <option value="7">Julio</option>
                          <option value="8">Agosto</option>
                          <option value="9">Septiembre</option>
                          <option value="10">Octubre</option>
                          <option value="11">Noviembre</option>
                          <option value="12">Diciembre</option>
                        </Form.Select>
                      </InputGroup>
                    </div>
                  </Col>
                  <Col Col xs={12} md={6} lg={3}>
                    <div className="form-group mb-4">
                      <label className="form-label">
                        <b>Atendido</b>
                      </label>
                      <InputGroup className="">
                        <InputGroup.Text id="basic-addon1">
                          <BsChevronExpand /> {" "}
                        </InputGroup.Text>
                        <Form.Select
                          className="form-control"
                          name="atendidoInput"
                          value={atendidoInput}
                          onChange={(e) => setAtendidoInput(e.target.value)}
                        >
                          <option value="">-- Seleccione estatus --</option>
                          <option value="true">Si</option>
                          <option value="false">No</option>
                        </Form.Select>
                      </InputGroup>
                    </div>
                  </Col>

                  <Col xs={6} md={1} className="d-flex gap-2">
                    <Button
                      variant="success"
                      className="w-100"
                      onClick={handleAplicarFiltros}
                      title="Aplicar"
                    >
                      <BsSearch />
                    </Button>

                    <Button
                      variant="dark"
                      className="w-100"
                      onClick={handleLimpiarFiltros}
                      title="Limpiar"
                    >
                      <BsEraserFill />
                    </Button>
                  </Col>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center ">
                <div className="d-flex align-items-center gap-2">
                  <span>Registros por página:</span>
                  <select
                    className="form-select form-select-sm"
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    style={{ width: "80px" }}
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                  </select>

                </div>
                <div className="text-muted">
                  Mostrando{" "}
                  <strong>
                    {currentPage * pageSize + 1}-
                    {Math.min((currentPage + 1) * pageSize, totalElements)}
                  </strong>{" "}
                  de <strong>{totalElements}</strong> registros
                </div>

                <div className="d-flex align-items-center gap-2">
                  <Button
                    variant="light"
                    onClick={handlePrevious}
                    disabled={currentPage === 0}
                    className="d-flex align-items-center gap-1"
                  >
                    <BsChevronLeft />
                    <span>Anterior</span>
                  </Button>

                  <Pagination className="mb-0">
                    {getPaginationItems()}
                  </Pagination>

                  <Button
                    variant="light"
                    onClick={handleNext}
                    disabled={currentPage >= totalPages - 1}
                    className="d-flex align-items-center gap-1"
                  >
                    <span>Siguiente</span>
                    <BsChevronRight />
                  </Button>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default WithRouter(Quejas);
